import Axios from "axios";
import { AxiosClient } from "../../utils/axios";
export const state = () => ({
  listVideo: [],
  videoLoading: false,
});

export const mutations = {
  SET_LIST_VIDEO(state, payload) {
    state.listVideo = payload;
  },
  SET_VIDEO_LOADING(state, payload) {
    state.videoLoading = payload;
  },
};

export const actions = {
  async getListVideo({ commit }) {
    commit("SET_VIDEO_LOADING", true);
    try {
      const domain = this.$config.BASE_URL_CLIENT;
      // const res = await AxiosClient.get("/api/video/get-list-video");
      const res = await Axios.get(`${domain}/api/school/get-list-video`, {});
      const { code, data } = res.data;
      if (code == 200) {
        commit("SET_LIST_VIDEO", data);
      } else {
        commit("SET_LIST_VIDEO", []);
      }
    } catch (error) {
      commit("SET_LIST_VIDEO", []);
      console.log(error);
    }
    commit("SET_VIDEO_LOADING", false);
  },
};
